import { render, staticRenderFns } from "./threads-list.vue?vue&type=template&id=530f34d0&"
import script from "./threads-list.vue?vue&type=script&lang=js&"
export * from "./threads-list.vue?vue&type=script&lang=js&"
import style0 from "./threads-list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports